import { parseMarketOutcomes } from '@/utils/market-outcomes';
import {
  SPORT_MARKET_TYPES,
  sportMarketTypeOf,
  isSportFiveTypeMarket,
} from '@/utils/sport-market-types.js';

function formatDateGroup(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso).slice(0, 10);
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

/** 主盘：match_winner 优先；否则 slug 与 collection 一致；再回落队名二元 / 成交量 */
export function pickPrimarySportMarket(row, markets) {
  const list = Array.isArray(markets) ? markets : [];
  if (!list.length) return null;

  const byType = list.find((m) => sportMarketTypeOf(m) === SPORT_MARKET_TYPES.MATCH_WINNER);
  if (byType) return byType;

  const collectionSlug = String(row?.slug ?? '').trim();
  if (collectionSlug) {
    const bySlug = list.find((m) => String(m?.slug ?? '').trim() === collectionSlug);
    if (bySlug) return bySlug;
  }

  const moneyline = list.find((m) => {
    if (isSportFiveTypeMarket(m)) return false;
    const outcomes = parseMarketOutcomes(m?.outcomes);
    if (outcomes.length !== 2) return false;
    const normalized = outcomes.map((o) => String(o).trim().toLowerCase());
    if (normalized.includes('over') || normalized.includes('under')) return false;
    if (normalized.includes('yes') && normalized.includes('no')) return false;
    if (normalized.some((o) => /^over\s/.test(o) || /^under\s/.test(o))) return false;
    return true;
  });
  if (moneyline) return moneyline;

  return [...list].sort(
    (a, b) => Number(b?.volume24hr ?? b?.volume ?? 0) - Number(a?.volume24hr ?? a?.volume ?? 0)
  )[0];
}

/** 体育列表：按 collection startDate 分组卡片 */
export function groupSportCardsByDate(cards, rows) {
  const rowById = new Map(
    (Array.isArray(rows) ? rows : []).map((row) => [String(row?.id ?? '').trim(), row])
  );
  const byDate = {};
  for (const card of Array.isArray(cards) ? cards : []) {
    const row = rowById.get(String(card?.id ?? '').trim());
    const date = formatDateGroup(row?.startDate);
    if (!byDate[date]) byDate[date] = [];
    byDate[date].push(card);
  }
  return Object.keys(byDate).map((date) => ({
    date,
    cards: byDate[date],
  }));
}
